import { ICompany } from './companiesTypes';
import { IThisUser } from 'store/store';

export const SupportRole = 'پشتیبان رستک';
export const CompanyAdvanceAdminRole = 'مدیر حرفه‌ای سامانه';

export const AutoRolePermissionSchemeIndex = 1_000_000_000;
export function isCompanySupport(
  thisUser: IThisUser | number,
  company: ICompany
) {
  const thisUserId =
    typeof thisUser === 'number' ? thisUser : Number(thisUser.userId);

  return (
    Boolean(
      Object.values(company?.members?.[thisUserId]?.roles || {})?.find((it) =>
        it.name.includes(SupportRole)
      )
    ) && isCompanyAdmin(thisUser, company)
  );
}
export function isAdvanceAdmin(
  thisUser: IThisUser | number,
  company: ICompany
) {
  const thisUserId =
    typeof thisUser === 'number' ? thisUser : Number(thisUser.userId);

  return (
    Boolean(
      Object.values(company?.members?.[thisUserId]?.roles || {})?.find((it) =>
        it.name.includes(CompanyAdvanceAdminRole)
      )
    ) && isCompanyAdmin(thisUser, company)
  );
}

export function isCompanyOwner(
  thisUser: IThisUser | number,
  company: ICompany
) {
  if (!thisUser || !company) return false;

  const thisUserId =
    typeof thisUser === 'number' ? thisUser : Number(thisUser.userId);
  return Number(company?.owner?.userId) === thisUserId;
}

export function isCompanyOwnerOrSupport(
  thisUser: IThisUser | number,
  company: ICompany,
  allowAdvancedAdmin: boolean = false
) {
  return (
    isCompanyOwner(thisUser, company) ||
    isCompanySupport(thisUser, company) ||
    (allowAdvancedAdmin && isAdvanceAdmin(thisUser, company))
  );
}

export function isCompanyAdmin(
  thisUser: IThisUser | number,
  company: ICompany
) {
  const thisUserId =
    typeof thisUser === 'number' ? thisUser : Number(thisUser.userId);
  return company?.members?.[thisUserId]?.admin ?? false;
}
export function isCompanyUser(thisUser: IThisUser | number, company: ICompany) {
  const thisUserId =
    typeof thisUser === 'number' ? thisUser : Number(thisUser.userId);
  return (
    company?.members?.[thisUserId] &&
    company?.members?.[thisUserId]?.inactive !== true
  );
}
